import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import moment from 'moment';
import HttpClient from '../../utils/HttpClient';
import { useLanguage } from '../../Providers/LanguageContext';
import { useUserData } from '../../Providers/UserWrapper';

const SetupInvDocs = ({ singleUserData, setCallGetAcc }) => {

    const { language, currentLanguage } = useLanguage()
    const { setIsLoading } = useUserData();

    const [setupDocData, setSetupDocData] = useState([])

    // console.log("singleUserData", singleUserData)

    const InitBlankDocData = {
        docType: "",
        dueDate: "",
        status: "",
        fileUrl: "",
        fileName: "",
        fileUrlNew: "",
        fileNameNew: ""
    }

    const [docData, setDocData] = useState([])
    console.log("docData_ddd", docData)


    // return attach, missing, pastDue
    const statusOfDoc = (date, file) => {
        console.log("dfg5fd6", date, file)
        const checkDate = moment(date).isAfter(moment().format("YYYY-MM-DD")) || moment(date).isSame(moment().format("YYYY-MM-DD"))
        // console.log("momentt", date, moment(date).isSame(moment().format("YYYY-MM-DD")))
        if (date) {
            if (checkDate) {
                if (file) {
                    return "Attached"
                }
                else {
                    return "Missing"
                }
            } else {
                return "Past Due"
            }
        } else {
            return "-"
        }
    }

    // handle change
    const handleChange = (e, i) => {
        const { name, value } = e.target;
        setDocData(prev => prev.map((item, ind) => {
            if (i === ind) {
                return { ...item, [name]: value }
            } else {
                return item
            }
        }))
    }

    // handle change
    const handleChangeNew = (e, i) => {
        const { name, value } = e.target;
        setDocData(prev => prev.map((item, ind) => {
            if (i === ind) {
                return { ...item, [name]: value }
            } else {
                return item
            }
        }))
    }

    // handle change pdf
    const handlePdfUpload = async (e, i) => {
        const file = e.target.files[0]
        console.log("filesdd", file?.name)
        if (file) {
            const data = new FormData();
            data.append("pdfFile", file)
            // console.log('imgData',data)
            setIsLoading(true)
            const res = await HttpClient.fileUplode("bookkeeper/upload-pdf", "POST", data);
            // console.log('imgres', res)
            setIsLoading(false)
            if (res && res.status) {
                handleChange({ target: { name: "fileUrl", value: res?.url } }, i)
                handleChange({ target: { name: "fileName", value: file?.name } }, i)
                // setTaxDetData(prev => ({ ...prev, pdf: res?.url }))
                toast.success("Document Uploaded Successfully")
            } else {

            }
        }
    }

    const handleUpload = async (e, i) => {
        const file = e.target.files[0]
        console.log("filesdd", file?.name)
        if (file) {
            const data = new FormData();
            data.append("pdfFile", file)
            // console.log('imgData',data)
            setIsLoading(true)
            const res = await HttpClient.fileUplode("investor/upload-pdf-by-investor2", "POST", data);
            // console.log('imgres', res)
            setIsLoading(false)
            if (res && res.status) {
                handleChangeNew({ target: { name: "fileUrlNew", value: res?.url } }, i)
                handleChangeNew({ target: { name: "fileNameNew", value: file?.name } }, i)
                // setTaxDetData(prev => ({ ...prev, pdf: res?.url }))
                toast.success("Document Uploaded Successfully")
            } else {
                toast.error(res?.message)
            }
        }
    }

    // handle oublish
    const handlePublish = async () => {
        const data = {
            "Data": docData?.map(item => ({
                "documentType": item.docType,
                "dueDate": moment(item?.dueDate).format("YYYY-MM-DD"),
                "status": statusOfDoc(item?.dueDate, item?.fileUrl),
                "pdf": item?.fileUrl,
                "pdfName": item?.fileName,
                "pdf2": item?.fileUrlNew,
                "pdfName2": item?.fileNameNew,
            }))
        }
        // console.log("datadsdfgff", data)
        // return
        setIsLoading(true)
        const res = await HttpClient.requestData("investor/add-investor-expense-manage-document/" + singleUserData?.accountRegCode, "PUT", data)
        setIsLoading(false)
        if (res && res?.status) {
            toast.success("Document Published Successfully!")
            getSetupManageDocs()
            setCallGetAcc(prev => !prev)
        } else {
            toast.error(res?.message)
        }
    }

    // get data
    const getSetupManageDocs = async () => {
        setIsLoading(true)
        const res = await HttpClient.requestData("investor/get-investor-expense-manage-document/" + singleUserData?.accountRegCode, "GET")
        console.log("resffxcc", res?.data, res?.data?.fileUrl)
        setIsLoading(false)
        if (res && res?.status) {
            setSetupDocData(res?.data)
            if (res?.data) {
                const newData = res?.data?.Data?.length !== 0
                    &&
                    res?.data?.Data?.map(item => ({
                        docType: item?.documentType,
                        dueDate: moment(item?.dueDate).format("YYYY-MM-DD"),
                        // status: item,
                        fileUrl: item?.pdf,
                        fileName: item?.pdfName,
                        fileUrlNew: item?.pdf2,
                        fileNameNew: item?.pdfName2
                    }))
                setDocData(newData)
                // :
                //     initDocData
                // setDocData(newData)
            }
        }
    }

    // send renuinder
    const handleSendReminder = async (item) => {
        if (!setupDocData && !setupDocData?._id) {
            return toast.error("Please publish the document first..!")
        }
        const data = {
            "documentType": item?.docType,
            "dueDate": item?.dueDate,
            "status": statusOfDoc(item?.dueDate, item?.fileUrl),
            "language": currentLanguage === "eng" ? "EN" : "ES"
        }
        // console.log("itemdff", item)
        setIsLoading(true)
        const res = await HttpClient.requestData("investor/send-missing-mail-user/" + setupDocData?._id, "POST", data)
        setIsLoading(false)
        if (res && res.status) {
            toast?.success("A Reminder Mail has been Sent to The User")
        } else {
            toast.error(res?.message)
        }
    }


    useEffect(() => {
        getSetupManageDocs();
    }, [])


    return (
        <div>
            <div>
                <h4 className='bookSecModalHead'>{singleUserData?.client_name}: Setup & Manage Documents</h4>
                <button
                    className='bookmodalAddBtn'
                    onClick={() => {
                        setDocData(prev => [InitBlankDocData, ...prev])
                    }}
                >
                    <i className="fa-solid fa-plus"></i>ADD
                </button>
                <div className='manageSliderInn'>
                    <div className='missingDocTbl'>
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Document Type</th>
                                    <th>Due Date</th>
                                    <th>Status</th>
                                    <th>Reminder</th>
                                    {/* <th>Upload</th> */}
                                    <th>User Documents</th>
                                    <th>Upload Example File</th>
                                    <th>Example Documents</th>
                                </tr>
                            </thead>
                            <tbody>
                                {docData?.map((item, i) => {
                                    const checkDate = moment(item?.dueDate).isAfter(moment().format())
                                    // console.log("checkDatevv", checkDate)
                                    return (
                                        <tr key={i}>
                                            <td>
                                                {/* <button className='bookModalBtn'>{item?.docType}</button> */}
                                                {/* <input type='text' className='bookModalBtn' /> */}
                                                <span
                                                    className='setDocManageTrushBtn'
                                                    onClick={() => {
                                                        setDocData(prev => prev.filter((ele, ind) => i !== ind))
                                                    }}
                                                >
                                                    <i class="fa-solid fa-trash"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    className="setupDocInp"
                                                    id="exampleFormControlInput1"
                                                    placeholder="Document Type"
                                                    name='docType'
                                                    value={item?.docType}
                                                    onChange={(e) => handleChange(e, i)}
                                                />
                                            </td>
                                            <td>
                                                {/* <button className='bookModalBtn'>Select</button> */}
                                                <input
                                                    type='date'
                                                    className='setupDocInp'
                                                    name='dueDate'
                                                    value={item?.dueDate}
                                                    onChange={(e) => handleChange(e, i)}
                                                />
                                            </td>
                                            <td>
                                                {
                                                    statusOfDoc(item?.dueDate, item?.fileUrl) === "Attached"
                                                    && <div className='text-success'>Attached</div>
                                                }
                                                {
                                                    statusOfDoc(item?.dueDate, item?.fileUrl) === "Missing"
                                                    && <div className='text-primary'>Missing</div>
                                                }
                                                {
                                                    statusOfDoc(item?.dueDate, item?.fileUrl) === "Past Due"
                                                    && <div className='text-danger'>Past Due</div>
                                                }
                                                {
                                                    statusOfDoc(item?.dueDate, item?.fileUrl) === "-"
                                                    && <div className='text-warning'>-</div>
                                                }
                                                {
                                                    // checkDate
                                                    //     ?
                                                    //     item?.fileUrl
                                                    //         ?
                                                    //         <div className='text-success'>Attached</div>
                                                    //         :
                                                    //         <div className='text-primary'>Missing</div>
                                                    //     :
                                                    //     <div className='text-danger'>Past Due</div>
                                                }
                                            </td>
                                            <td>
                                                <button
                                                    className='buildCapTblBtn'
                                                    onClick={() => handleSendReminder(item)}
                                                >
                                                    Send
                                                </button>
                                            </td>

                                            {/* <td >
                                                <div style={{ position: "relative" }}>
                                                    <button className='buildCapTblBtn'>Browse</button>
                                                    <input
                                                        className='setupDocFileInp'
                                                        type="file"
                                                        onChange={(e) => handlePdfUpload(e, i)}
                                                    />
                                                </div>
                                            </td> */}

                                            <td>
                                                {
                                                    item?.fileUrl &&
                                                    <div className='d-flex'>
                                                        <a href={item?.fileUrl} target='_blank' className='buildCapMidlink'>{item?.fileName}</a>
                                                        (<span
                                                            className='text-danger'
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                handleChange({ target: { name: "fileUrl", value: "" } }, i)
                                                                handleChange({ target: { name: "fileName", value: "" } }, i)
                                                            }}
                                                        >
                                                            remove
                                                        </span>)
                                                    </div>
                                                }
                                            </td>

                                            <td>
                                                <div style={{ position: "relative" }}>
                                                    <button className='buildCapTblBtn'>Browse</button>
                                                    <input
                                                        className='setupDocFileInp'
                                                        type="file"
                                                        onChange={(e) => handleUpload(e, i)}
                                                    />
                                                </div>
                                            </td>

                                            <td>
                                                {
                                                    item?.fileUrlNew &&
                                                    <div className='d-flex'>
                                                        <a href={item?.fileUrlNew} target='_blank' className='buildCapMidlink'>{item?.fileNameNew}</a>
                                                        (<span
                                                            className='text-danger'
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                handleChangeNew({ target: { name: "fileUrlNew", value: "" } }, i)
                                                                handleChangeNew({ target: { name: "fileNameNew", value: "" } }, i)
                                                            }}
                                                        >
                                                            remove
                                                        </span>)
                                                    </div>
                                                }
                                            </td>

                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                </div>
                <button
                    className='bookSecPublish'
                    onClick={() => handlePublish()}
                >
                    Publish
                </button>
            </div>

        </div>
    )
}

export default SetupInvDocs



